import {StyledTableBodyRow} from '@components/ui/table-body-row/style.ts'
import {TableBodyRowProps} from '@components/ui/table-atoms/TableAtoms.tsx'

export const TableBodyRow = (props: TableBodyRowProps) => <StyledTableBodyRow {...props} />
